import type { Opaque } from '@bonsai-components/utility-types';
import { v4 as uuidV4 } from 'uuid';
import { safeSessionStorage } from './local-storage.helper';

export type UUID = Opaque<string, 'uuid'>;

export const uuid = (): UUID => {
  return uuidV4() as UUID;
};

const TAB_ID_KEY = 'tabId';

/**
 * Holds the id for this document when sessionStorage refuses the write.
 * `downloads.context` calls `getTabId()` inside a filter predicate, so without
 * this a fresh id per call would make `manifest.tabId === getTabId()` never
 * match — downloads would be unclaimable within a single page load.
 */
let unpersistedTabId: UUID | null = null;

export function getTabId() {
  // Deliberately no `window.name` fallback: it is not always a tab id we set
  // (`use-scm-authorization-popup` names its popup `scm-auth-popup`), so
  // reading it back would hand out a non-UUID that download-job matching in
  // `downloads.context` treats as a real tab.
  let value: string = safeSessionStorage.getItem(TAB_ID_KEY);

  if (!value || !window.name) {
    value = uuid();
    if (!safeSessionStorage.setItem(TAB_ID_KEY, value)) {
      unpersistedTabId ??= value as UUID;
      value = unpersistedTabId;
    }
  }

  window.name = value;
  return value as UUID;
}
